import { useAppSelector } from 'app/hooks';
import Typo from 'consts/typography';
import { useMatchTimeCountdown } from 'hooks/useMatchTimeCountdown';
import useThemes from 'hooks/useThemes';
import { MatchTimeResponse } from 'models';
import React from 'react';
import { platformStates } from 'redux/platformSlice';

interface MatchLiveInfoProps {
  matchTime: MatchTimeResponse;
}

const MatchLiveInfo: React.FunctionComponent<MatchLiveInfoProps> = ({ matchTime }) => {
  const countdown = useMatchTimeCountdown(matchTime);
  const { currentTheme } = useThemes();
  const { isPhone } = useAppSelector(platformStates);

  return (
    <p
      className={`primary-text-color m-0 pb-1 ${isPhone ? Typo.p7 : Typo.p3} ${
        currentTheme === 'dark' ? 'neon-white' : ''
      }`}
    >
      {`${matchTime.currentPhase} ${countdown ?? '--:--'}`}
    </p>
  );
};

export default MatchLiveInfo;
